import React from "react";
import "./NewsItem.css";

const newsItems = [
  { key: "Cloud Migration Services" },
  { key: "Custom Software Development" },
  { key: "Application Modernization" },
  { key: "Azure Virtual Machines (VMs)" },
  { key: "API Development and Integration" },
  { key: "Azure Functions and Serverless Solutions" },
  { key: "Database Design and Optimization" },
  { key: "Azure DevOps Setup and Automation" },
  { key: "Scalable Web Applications" },
  { key: "Azure Active Directory Integration" },
  { key: "CI/CD Pipeline Implementation" },
  { key: "Mobile App Development" },
  { key: "Azure Kubernetes Service (AKS)" },
  { key: "Microservices Architecture" },
  { key: "Azure Logic Apps Automation" },
  { key: "Cloud Security and Governance" },
  { key: "Database Development" },
  { key: "Data Analytics and Insights with Azure" },
  { key: "Microsoft Intune Services" },
  { key: "On-Prem Active Directory" },
  { key: "Automation" },
  { key: "Microsoft Exchange" },
  { key: "Microsoft M365 Solutions" },
  { key: "Dockerization" },
  { key: "Cost Optimization for Azure" }
];

const NewsTicker = () => {
  const doubledItems = [...newsItems, ...newsItems]; // Double the content for seamless scrolling

  return (
    <div className="ticker-root">
      <div className="ticker-wrapper">
        <div className="ticker-inner">
          {doubledItems.map((item, index) => (
            <div className="ticker-element" key={`${item.key}-${index}`}>
              {item.key}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;